import { data } from 'currency-codes';

// Currency codes is a npm package to list and work on currency codes based on the ISO 4217 standard.
// https://www.npmjs.com/package/currency-codes
export const currencies=new Map<string,string>(data.sort((a,b)=>a.currency.localeCompare(b.currency)).map(x=>[x.code,x.currency]));
